import { Injectable } from '@angular/core';

export interface AppRuntimeConfig {
    apiBaseUrl: string;
    recaptchaSiteKey: string;
}

@Injectable({ providedIn: 'root' })
export class AppConfigService {
    private cfg!: AppRuntimeConfig;

    async load(): Promise<void> {
        const res = await fetch('/assets/config.json', { cache: 'no-store' });
        if (!res.ok) {
            throw new Error(`Could not load /assets/config.json (${res.status})`);
        }
        this.cfg = await res.json();
    }

    get apiBaseUrl(): string {
        return this.cfg.apiBaseUrl;
    }

    get recaptchaSiteKey(): string {
        return this.cfg.recaptchaSiteKey;
    }
}
